import React from 'react';
import { Navigate, NavLink } from 'react-router-dom';
import { Server } from '../../server/server';
import AlertModal from '../modals/AlertModal';
import MessageModal from '../modals/MessageModal';
import FriendPanel from '../elements/FriendPanel';
import './MessagesPage.css'
import { getPortraitImage } from '../util/util';
import { BsCaretRight } from 'react-icons/bs';

interface MessagesPageState {
  alert: string;
  message: string;
  navigate: string;
}

class MessagesPage extends React.Component<{}, MessagesPageState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      alert: '',
      message: '',
      navigate: ''
    };

    this.onFriendUpdated = this.onFriendUpdated.bind(this);
    this.onChatUpdated = this.onChatUpdated.bind(this);
  }

  componentDidMount() {
    Server.user.addEventListener('friend-updated', this.onFriendUpdated);
    Server.messages.addEventListener('chat-updated', this.onChatUpdated);
  }

  componentWillUnmount() {
    Server.user.removeEventListener('friend-updated', this.onFriendUpdated);
    Server.messages.removeEventListener('chat-updated', this.onChatUpdated);
  }

  onFriendUpdated(data: any) {
    this.forceUpdate();
  }

  onChatUpdated(data: any) {
    this.forceUpdate();
  }

  onChat(friendId:string) {
    let chat = Server.messages.getDirectChat(friendId);

    if(chat) {
      this.setState({navigate: '/chat/' + chat.id})
      return;
    }

    this.setState({message: 'Starting chat...'});

    setTimeout(async () => {
      let response = await Server.messages.startDirectChat(friendId);

      if(response.success) {
        chat = Server.messages.getDirectChat(friendId);
        this.setState({navigate: '/chat/' + chat.id});
      }
      else {
        this.setState({alert: response.message, message: ''})
      }
    }, 500);
  }

  renderChats() {
    if(this.state.navigate)
      return (<Navigate to={this.state.navigate} />);

      let friends = Server.user.getFriends();

    if(friends.length == 0) {
      return( 
        <div style={{color: '#ffffff80'}}>
          Send direct messages between friends.  You can invite friends on the <NavLink style={{color: 'white'}} to="/friends">Friends</NavLink> page.
        </div>        
      )
    }

    let sortedFriends = [];
    for(let i = 0; i < friends.length; i++) {
      if(friends[i].state != 'accepted')
        continue;
      let profile  = Server.public.getProfile(friends[i].id);
      let friend:any = {...profile, ...friends[i]};
      sortedFriends.push(friend);
    }

    sortedFriends.sort((a, b)=>{
      if((a.presence && a.presence.online) && (!b.presence || !b.presence.online))
        return -1;
      else if((!a.presence || !a.presence.online) && (b.presence && b.presence.online))
        return 1;
        
      if(a.name > b.name)
        return 1;
      else if(a.name < b.name)
        return -1;

      return 0;
    })

    let divs = [];
    for(let i = 0; i < sortedFriends.length; i++) {
      let friend = sortedFriends[i];
      let chat = Server.messages.getDirectChat(friend.id);
      let notify = (chat && chat.updated);
      divs.push(
        <div key={i.toString()} className="messages-page-chat-row" onClick={()=>this.onChat(friend.id)}>
          <div className="messages-page-chat-name">
            <img className="messages-page-portrait" src={getPortraitImage(friend)} />
            {friend.presence && friend.presence.online &&
              <div className="messages-page-green-circle" />
            }
            <div>{friend.name}</div>
            {notify &&
              <div className="messages-page-red-circle" />
            }
          </div>
          <div className="messages-page-chat-action">
            <div className="messages-page-chat-next"><BsCaretRight /></div>
          </div>
        </div>
      )
    }

    return divs;
  }

  render() {
    if(!Server.account.isLoggedIn())
      return <Navigate to="/" replace />;
      
    return (
      <div className="messages-page">

        <div className='messages-page-header'>
          Select a chat:
        </div>

        <div className="messages-page-contents">
          {this.renderChats()}
        </div>

        <MessageModal message={this.state.message} />
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
      </div>
    );
  }
}

export default MessagesPage;